import axios from "axios"

const setDrawerOpen = (context, data) => {
  context.commit("DRAWER_OPEN", data)
}

const setAlert = (context, data) => {
  context.commit("ALERT", data)
}

const setLoader = (context, data) => {
  context.commit("LOADER", data)
}

const setCurrentModule = (context, data) => {
  context.commit("CURRENT_MODULE", data)
}

const setAxiosHideLoader = (context, data) => {
  context.commit("AXIOS_HIDE_LOADER", data)
}

const setTogglePushNotification = (context, data) => {
  context.commit("TOGGLE_PUSH_NOTIFICATION", data)
}

const setNewVersionSnackbar = (context, data) => {
  context.commit("NEW_VERSION_SNACKBAR", data)
}

const setRouteCount = (context, data) => {
  context.commit("ROUTE_COUNT", data)
}

const increaseRouteCount = (context) => {
  var count = context.rootState.master.routeCount + 1
  context.commit("ROUTE_COUNT", count)
}

const setVersionCheck = (context, data) => {
  context.commit("VERSION_CHECK", data)
}

export default {
  setLoader,
  setDrawerOpen,
  setAlert,
  setCurrentModule,
  setAxiosHideLoader,
  setTogglePushNotification,
  setNewVersionSnackbar,
  setRouteCount,
  increaseRouteCount,
  setVersionCheck
}
